<template>
  <div
    v-if="loadingGmf"
    class="flex-1 f-center anim-fade-in_slow"
  >
    <LoaderWLogo />
  </div>
  <div
    v-else
    class="rap-container flex-1 f-column flex-1"
  >
    <RangeBuilderV2
      ref="rangeBuilder"
      class="z-index_1"
      :namespace
      :onStart="builderConfigure"
      :canInitialize
      :useHex
      :grouping
      :showBetsIn
      :showEvIn
      :mobile
      :gameformat
      :solElite
      :hasPremiumGameformat
      :street="hSpot_street"
      :messages="bui_messages"
      :hotkeysPressed="hotkeysPressedBottom"
      :solDynamic="l_sol_dynamic"
      :solStatic="l_sol_static"
      :randomBoard
      :solution_picked="solution_picked"
      :filterCombos="filterCombos"
      :swLayoutStudy="$store.getters.sw_layout_study"
      :swSpacingStudy="$store.getters.sw_layout_spacing_study"
      :filterCategories="filterCategories"
      :heroGroup="heroDetail.group"
      :heroGroupId="heroDetail.group_id"
      :heroGroupsIds="heroDetail.groups_ids"
      :tableMouseover
      :viewProps="$store.getters.sol_view_viewProps"
      :hSpot="$store.getters.sol_data_hSpot"
      :solStreet="$store.getters.sol_data_street"
      @click:new_board="start"
      @reset="setCanInitialize(false)"
    >
      <template #start>
        <transition
          name="fade"
          mode="out-in"
        >
          <RangeBuilderStart
            v-if="builderConfigure"
            class="anim-fade-in z-index_4"
            @start="start"
          />
        </transition>
      </template>
      <template #after>
        <StudyMessageOverlay
          v-if="bui_messages"
          style="z-index: 5"
          :messages="bui_messages"
          :canAISolve="false"
          :street="hSpot_street"
          :solElite
          :pageKey="'solutions'"
        />
      </template>
      <template #hSpots>
        <PokerHistoryEvents
          :namespace="''"
          :canAISolve="false"
          :hasTmpBoard="true"
          :hasGameformat="true"
          :hasWatcherEnabled="true"
          :hasInitialLoad="true"
          :hasFilter="!solElite.want_use"
          :noNextActionsWithoutBoard="solElite.want_use"
          :hasTurnPreload="!solElite.want_use"
          :hasNodeEdit="false"
          :hiddenShortcutBtns="solElite.want_use ? ['shortcut'] : []"
          :isMinimizedVertical="mobile && !$store.getters.screen_landscape"
          :solElite
          :dialog="solElite.want_use ? 'cards-dialog' : 'practice-filter-dialog'"
          style="--clr-hero: var(--clr-hero-default)"
          @click="goToStart"
        />
      </template>
    </RangeBuilderV2>
    <SnackbarLinkGuide
      localKey="rangebuilder_how_to_use"
      :link="links_url_links.rangebuilder_how_to_use.url"
      :text="$t('messages.get_most_of_rangebuilder')"
    />
    <portal
      to="main_before"
      :order="1"
    >
      <FloatingGmfSelector v-if="!mobile" />
      <FloatingBubbleFactor
        v-if="!mobile"
        namespace=""
      />
    </portal>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import SnackbarLinkGuide from '@/components/Messages/SnackbarLinkGuide'
import { SNK } from '@/helpers/helpers'
import RangeBuilderV2 from '@/components/Practice/RangeBuilder/RangeBuilderV2'
import RangeBuilderStart from '@/components/Practice/RangeBuilder/RangeBuilderStart'
import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import StudyMessageOverlay from '@/components/Poker/Overlays/StudyMessageOverlay'
import FloatingGmfSelector from '@/components/GameFormat/GmfSelektor/FloatingGmfSelector'
import FloatingBubbleFactor from '@/components/BubbleFactor/FloatingBubbleFactor'
import LoaderWLogo from '@/components/Loaders/LoaderWLogo.vue'
import links_mix from '@/mixins/links_mix'
import { sendGaEvent } from '@gto/analytics/google-analytics'

export default {
  name: 'PracticeRangeBuilder',
  components: {
    RangeBuilderStart,
    RangeBuilderV2,
    FloatingGmfSelector,
    FloatingBubbleFactor,
    PokerHistoryEvents,
    StudyMessageOverlay,
    LoaderWLogo,
    SnackbarLinkGuide,
  },
  mixins: [links_mix],
  data() {
    this.namespace = 'tmp/primary'
    return {
      canInitialize: true,
      loadingGmf: true,
    }
  },
  mounted() {
    this.sendGaEvent({
      event: 'page_opened',
      page: 'range_builder',
    })
  },
  async created() {
    await this.$store.dispatch('gameformats_init_pageViewStores', { forceInit: true })
    this.loadingGmf = false
  },
  beforeUnmount() {
    this.$store.commit('globals_set', { key: 'rangebuilder_configure', value: true })
  },
  methods: {
    sendGaEvent,
    initializeBuilder() {
      if (this.canInitialize && this.sol_loaded && this.solution_picked.length) {
        if (this.sol_status === 200) {
          setTimeout(() => {
            this.$store.dispatch('globals_action', 'component_triggered_tour_PracticeRangeBuilder')
          }, 120)
        }
        nextTick(() => {
          this.$refs.rangeBuilder.initialize()
        })
      }
    },
    goToStart() {
      this.$store.commit('filters_reset')

      if (this.$refs.rangeBuilder) {
        this.$refs.rangeBuilder.resetState()
        this.setCanInitialize(false)
      }
      this.$store.commit('globals_set', { key: 'rangebuilder_configure', value: true })
      this.$store.dispatch('router_update_query', {
        query: { board_tmp: '' },
        push: false,
      })
    },
    async start() {
      this.$store.commit(SNK('sol_filters_set', this.namespace), {
        key: 'suits',
        value: {
          suited: [],
          offsuited: [],
          exclude_suited: [],
          exclude_offsuited: [],
        },
      })
      this.$store.dispatch('switchers_set_item_by_value', {
        key: 'sw_tabs_handmatrix',
        value: 'hands',
      })
      this.$store.commit('globals_set', { key: 'rangebuilder_configure', value: false })
      const { history_spot_board } = this.$store.getters
      if (this.street !== 'preflop') {
        if (history_spot_board.some(cId => cId.includes('E'))) {
          await this.$store.dispatch('api_practice_builder')
        }
      }
      this.setCanInitialize(true)
      this.getData()
    },
    setCanInitialize(bool) {
      this.canInitialize = bool
    },
    getData() {
      this.$store.dispatch('api_poker_solution', { namespace: '' })
      this.initializeBuilder()
    },
  },
  computed: {
    heroDetail() {
      return this.$store.getters[SNK('sol_detail_players', this.namespace)][0]
    },
    tableMouseover() {
      return this.$store.getters[SNK('sol_detail_tableMouseover', this.namespace)]
    },
    filterCategories() {
      return this.$store.getters[SNK('sol_filter_categories', this.namespace)]
    },
    filterCombos() {
      return this.$store.getters[SNK('sol_filter_combos', this.namespace)]
    },

    solution_picked() {
      return this.$store.getters.sol_data_solution_picked
    },
    l_sol_dynamic() {
      const res = {
        tableGroups: this.$store.getters.sol_data_tableGroups(),
        combos: this.$store.getters.sol_data_combos(),
        solution: this.$store.getters.sol_data_solution(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
    l_sol_static() {
      const res = {
        solData: this.$store.getters.sol_data_solData(),
        catDraws: this.$store.getters.sol_data_catDraws(),
        catHands: this.$store.getters.sol_data_catHands(),
        catEqBuckets: this.$store.getters.sol_data_catEqBuckets(),
        catEqBucketsAdvanced: this.$store.getters.sol_data_catEqBucketsAdvanced(),
        players: this.$store.getters.sol_data_players(),
        // TODO rm after 3way rls
        hero: this.$store.getters.sol_data_players()[0],
        opponent: this.$store.getters.sol_data_players()[1],
      }
      return this.$store.getters.sol_data_updated ? res : res
    },

    isPreflop() {
      return this.$store.getters.sol_data_street === 'preflop'
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    showEvIn() {
      return this.$store.getters.show_ev_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    gameformat() {
      return this.$store.getters.gameformat
    },
    solElite() {
      return this.$store.getters.sol_elite
    },
    hasEliteSingleFlopOnly() {
      const flopBoard = this.$store.getters
        .street_board('flop')
        .filter(i => i !== 'Ee')
        .join('')
      // console.log(this.solElite, flopBoard)
      return this.solElite.is_using && this.solElite.must_upgrade
        ? flopBoard && flopBoard !== 'QsTs7h'
        : false
    },
    hasPremiumGameformat() {
      if (this.solElite?.want_use) {
        const { subs } = this.$store.getters.user_info
        const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
        const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
        return !!(anyPremiumPurchased || anyElitePurchased)
      }
      return ['PREMIUM', 'ELITE'].some(i => this.gameformat?.subscription_tier === i)
    },
    hSpot() {
      return this.$store.getters.history_spot
    },
    hSpot_street() {
      return this.hSpot?.street
    },
    preflopOnlyGametype() {
      return this.$store.getters.preflopOnlyGametype
    },
    sol_hsBoard() {
      return this.$store.getters.history_spot_board
    },
    sol_noBoardCards() {
      return this.hSpot_street !== 'preflop' && this.sol_hsBoard.some(i => i.includes('E'))
    },
    historyLoading() {
      return (
        this.$store.getters.api_get('api_poker_next_actions').loading ||
        this.$store.getters.api_get('api_poker_history').loading
      )
    },
    randomBoard() {
      const board = this.$store.getters.street_board(this.hSpot_street)
      const res = board.includes('Ee')
      return res
    },
    setupLoading() {
      return this.$store.getters.api_get('api_practice_setup').loading
    },
    sol_apiCall() {
      return this.$store.getters.api_get('api_poker_solution')
    },
    sol_loading() {
      return this.sol_apiCall.loading
    },
    sol_loaded() {
      return this.sol_apiCall.loaded
    },
    sol_status() {
      return this.sol_apiCall.status
    },
    sol_error() {
      return this.sol_apiCall.error
    },

    nextActionsCall() {
      return this.$store.getters.api_get('api_poker_next_actions')
    },
    historyCall() {
      return this.$store.getters.api_get('api_poker_history')
    },
    historyError() {
      return this.nextActionsCall?.error || this.historyCall?.error
    },

    bui_messages() {
      if (!this.canInitialize) return null
      // return [
      // 'loading',
      // 'error_loading_solution',
      // '204',
      // '403',
      // '429',
      // 'preflopOnlyGametype',
      // ]

      const solutionTooBig =
        this.historyError?.status === 400 && this.historyError?.data?.code === 'TREE_IS_TOO_BIG'

      const opts = [
        { key: 'loading', val: this.sol_loading || this.historyLoading || this.setupLoading },

        { key: 'loading', val: this.solElite.loading_what === 'custom_solution' },

        {
          key: 'forced_fold',
          val: this.hSpot?.forced_fold,
        },

        { key: 'custom_sols_flop_elite_only', val: this.hasEliteSingleFlopOnly },
        { key: 'error_400_TREE_IS_TOO_BIG', val: solutionTooBig },
        { key: '204_elite', val: this.solElite.is_using && this.sol_status === 204 },

        { key: 'preflopOnlyGametype', val: !this.solElite.want_use && this.preflopOnlyGametype },

        { key: '204', val: this.sol_status === 204 },
        { key: '403', val: this.sol_status === 403 },
        { key: '429', val: this.sol_status === 429 },
        { key: 'error_loading_solution', val: this.sol_error },
      ]
      let res = null
      opts.forEach(i => {
        if (!res && i.val) {
          res = [i.key]
        }
      })
      return res
    },

    messages() {
      if (this.loading) {
        return ['loading']
      }
      if (this.preflopOnlyGametype) {
        return ['preflopOnlyGametype']
      }
      if ([204, 403, 429].includes(this.status)) {
        return [`${this.status}`]
      }
      return null
    },
    loading() {
      return this.api_practice_setup?.loading || this.api_poker_solution?.loading
    },
    status() {
      const res = this.$store.getters.api_get('api_poker_solution')
      return res.status
    },
    api_poker_solution() {
      const res = this.$store.getters.api_get('api_poker_solution')
      return res
    },
    api_practice_setup() {
      const res = this.$store.getters.api_get('api_practice_setup')
      return res
    },
    focusMode() {
      return this.$store.state.globals.practice_display_mode === 'focus'
    },
    street() {
      return this.$store.getters.street
    },
    praFocusMode() {
      return this.$store.state.globals.practice_display_mode === 'focus'
    },
    glo() {
      return this.$store.state.globals
    },
    hotkeyPressedBottom() {
      return this.$store.getters.hotkey_pressed_bottom
    },
    builderConfigure() {
      return this.$store.getters.rangebuilder_configure
    },
    hotkeysPressedBottom() {
      if (!this.sol_loaded) return null
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    // gameformat() {
    //   this.goToStart()
    // },
    historyLoading(val) {
      if (val) {
        this.goToStart()
      }
    },
    hotkeyPressedBottom(key) {
      if (!key) return
      if (!this.builderConfigure) return
      if (key === 'enter') {
        this.start()
      }
    },
    sol_loaded() {
      this.initializeBuilder()
    },
  },
}
</script>
<style lang="scss" scoped>
.rap-container {
  position: relative;
}
</style>
